import React from 'react';
import { View } from 'react-native';
import TableBubble from './TableBubble';
import TableText from '../PanelsComponents/Text/TableText';

const ServicesTableColumn = ({
  serviceIds, onChangeServices, notChosenServices,
}) => {
  const removeService = (serviceIdToRemove) => {
    onChangeServices(serviceIds.filter((serviceId) => serviceId !== serviceIdToRemove));
  };
  const onPress = (service) => {
    if (isValid(service)) {
      onChangeServices([...serviceIds, service]);
    }
  };

  const onChangeValue = (text) => {
    if (isValid(text)) {
      onChangeServices([...serviceIds, text]);
    }
  };
  const isValid = (serviceId) => notChosenServices.includes(serviceId);
  console.log('ServicesTableColumn');
  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
      {serviceIds.map((serviceId) => (
        <TableBubble
          key={serviceId}
          text={serviceId}
          removeService={() => removeService(serviceId)}
        />
      ))}
      <TableText
        onChangeValue={onChangeValue}
        notChosenServices={notChosenServices}
        clearInputOnSubmit
        onPress={onPress}
      />
    </View>
  );
};
export default ServicesTableColumn;
